import React from 'react';
import InfiniteScroll from '../InfiniteScroll';
import { render, screen } from '@testing-library/react';

describe('InfiniteScroll Component', () => {

  it('it renders its children', () => {
    const links = ['1', '2', '3', '4', '5'];
    const anchorLinks = links.map((link, index) =>
      <a key={index}>{link}</a>
    );
    render(
      <InfiniteScroll>
        <div>
          {anchorLinks}
        </div>
      </InfiniteScroll>
    );
    links.forEach(link =>
      expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'a' && content === link)).toBeInTheDocument()
    );
  });
});
